var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1242 4.34482H2.78105V3.14102H11.1242V4.34482ZM11.1242 6.15054H2.78105V4.94673H11.1242V6.15054ZM11.1242 7.95625H2.78105V6.75244H11.1242V7.95625ZM13.9053 1.93721C13.9053 1.61794 13.7588 1.31174 13.498 1.08599C13.2372 0.860228 12.8835 0.733398 12.5147 0.733398H1.39053C1.02174 0.733398 0.66805 0.860228 0.407276 1.08599C0.146502 1.31174 0 1.61794 0 1.93721V9.16006C0 9.47933 0.146502 9.78552 0.407276 10.0113C0.66805 10.237 1.02174 10.3639 1.39053 10.3639H11.1242L13.9053 12.7715V1.93721Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.5b3539e1ebc04e28d058406808190d56.svg";
export { ForwardRef as ReactComponent };